import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=64c4d840&scoped=true&lang=pug&"
import script from "./DocumentsView.vue?vue&type=script&lang=ts&"
export * from "./DocumentsView.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=64c4d840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4d840",
  null
  
)

export default component.exports